var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/48/Arch_AWS-CloudFormation_48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e7157b",
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.008 32.788h4.001v-2.022h-4.001zM23.003 42.9h4.001v-2.023h-4zm-8.002 0h5.002v-2.023H15zm0-5.056h9.003V35.82H15zm0-9.1h7.002V26.72h-7.002zm0 4.044h25.007v-2.022H15zm15.004 17.19H12.001v-26.29h18.004v5.055h2v-6.067c0-.558-.448-1.01-1-1.01H11c-.553 0-1 .452-1 1.01V50.99c0 .558.447 1.011 1 1.011h20.005c.552 0 1-.453 1-1.011V35.82h-2zM54 30.766c0 5.598-4.573 7.078-6.99 7.078H35.005V35.82H47.01c.508-.004 4.99-.177 4.99-5.055 0-4.06-2.8-5.85-4.157-6.081a1.007 1.007 0 0 1-.829-1.081l.004-.039c-.039-1.6-.817-2.77-2.151-3.217-1.296-.434-2.757-.052-3.468.91a.98.98 0 0 1-.95.396 1 1 0 0 1-.794-.66c-.47-1.33-1.157-2.198-2.113-3.165-2.3-2.307-4.577-3.58-8.204-2.288-1.646.585-3.624 2.602-4.411 4.494l-1.845-.784c1.01-2.427 3.414-4.842 5.592-5.617 4.892-1.744 7.944.417 10.28 2.762.793.803 1.459 1.587 1.99 2.572 1.275-.839 2.974-1.07 4.554-.54 1.973.663 3.234 2.306 3.479 4.473 2.207.774 5.024 3.284 5.024 7.865"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudformation);
export default __webpack_public_path__ + "static/media/cloudformation.bc7773a63ed2e90890e0dbd3751352c5.svg";
export { ForwardRef as ReactComponent };